import CssBaseline from '@material-ui/core/CssBaseline';
import {ThemeProvider} from '@material-ui/styles';
import moment from 'moment';
import 'moment/locale/de';
import ReactDOM from 'react-dom';

import './index.css';

import AppRouter from './App/AppRouter';
// TODO: Rename to AppTheme or something similiar (remove Zeiterfassung)
import createZeiterfassungTheme from './App/Theme';

// Set moment locale
moment.locale('de');

const ZeiterfassungTheme = createZeiterfassungTheme({});

ReactDOM.render(
	<>
		<CssBaseline />
		<ThemeProvider theme={ZeiterfassungTheme}>
			<AppRouter />
		</ThemeProvider>
	</>,
	document.getElementById('root')
);
